import React, { useState, useEffect } from 'react';
import styled from '../../../../styled';
import dayjs, { getLocaleKey } from '../day';
import CalendarHeader from './CalendarHeader';
import DateCalendarView from './DateCalendarView';
import MonthCalendarView from './MonthCalendarView';
import YearCalendarView from './YearCalendarView';
export const Grid = styled.div `
  width: 15.75rem;
`;
const RangeGridContainer = styled.div `
  display: flex;
  cursor: default;

  > ${Grid} {
    &:not(:first-of-type) {
      margin-left: 1rem;
    }

    &:not(:last-of-type) {
      margin-right: 1rem;
    }
  }
`;
const Calendar = ({ lang = 'en', open, isFocusOnToInput = false, selectedDate, selectedFrom, selectedTo, onChange = () => { }, disabledDate = () => false, isRangeMode = false, }) => {
    const [mode, setMode] = useState('DATE');
    const [targetDate, setTagetDate] = useState((selectedDate ||
        (isRangeMode && (selectedFrom || selectedTo)) ||
        dayjs(lang).set('minute', 0).set('second', 0)).locale(getLocaleKey(lang)));
    const onPageChanged = (diff) => () => {
        let newDate;
        if (mode === 'DATE') {
            newDate = targetDate.add(diff, 'month');
        }
        else if (mode === 'MONTH') {
            newDate = targetDate.add(diff, 'year');
        }
        else {
            newDate = targetDate.add(diff * 10, 'year');
        }
        setTagetDate(newDate);
    };
    const onMonthChanged = (m) => {
        setTagetDate(targetDate.month(m));
        setMode('DATE');
    };
    const onYearChanged = (y) => {
        setTagetDate(targetDate.year(y));
        setMode('MONTH');
    };
    useEffect(() => {
        if (isFocusOnToInput && open && selectedFrom && selectedTo) {
            if (selectedTo.isAfter(selectedFrom.add(1, 'month'))) {
                setTagetDate(selectedTo.subtract(1, 'month'));
            }
            else if (selectedFrom.isAfter(selectedTo)) {
                setTagetDate(selectedFrom.clone());
            }
        }
        else if (!isFocusOnToInput && open) {
            const date = selectedDate || selectedFrom;
            if (date)
                setTagetDate(date.clone());
        }
    }, [isFocusOnToInput, open, selectedDate, selectedFrom, selectedTo]);
    if (mode === 'DATE' && isRangeMode) {
        return (React.createElement(RangeGridContainer, null,
            React.createElement(Grid, null,
                React.createElement(CalendarHeader, { lang: lang, mode: mode, target: targetDate, onPrevPage: onPageChanged(-1), onNextPage: onPageChanged(1), onChangeMode: setMode, hideNextPage: true }),
                React.createElement(DateCalendarView, { lang: lang, target: targetDate, selectedDate: selectedDate, selectedFrom: selectedFrom, selectedTo: selectedTo, onSelect: onChange, disabledDate: disabledDate })),
            React.createElement(Grid, null,
                React.createElement(CalendarHeader, { lang: lang, mode: mode, target: targetDate.add(1, 'month'), onPrevPage: onPageChanged(-1), onNextPage: onPageChanged(1), onChangeMode: setMode, hidePrevPage: true }),
                React.createElement(DateCalendarView, { lang: lang, target: targetDate.add(1, 'month'), selectedDate: selectedDate, selectedFrom: selectedFrom, selectedTo: selectedTo, onSelect: onChange, disabledDate: disabledDate }))));
    }
    return (React.createElement(Grid, null,
        React.createElement(CalendarHeader, { lang: lang, mode: mode, target: targetDate, onPrevPage: onPageChanged(-1), onNextPage: onPageChanged(1), onChangeMode: setMode }),
        mode === 'DATE' && (React.createElement(DateCalendarView, { lang: lang, target: targetDate, selectedDate: selectedDate, onSelect: onChange, disabledDate: disabledDate })),
        mode === 'MONTH' && (React.createElement(MonthCalendarView, { lang: lang, target: targetDate, selectedDate: selectedDate, selectedFrom: selectedFrom, selectedTo: selectedTo, onSelect: onMonthChanged })),
        mode === 'YEAR' && (React.createElement(YearCalendarView, { target: targetDate, selectedDate: selectedDate, selectedFrom: selectedFrom, selectedTo: selectedTo, onSelect: onYearChanged }))));
};
export default Calendar;
//# sourceMappingURL=index.js.map